<template>
  <div class="box">
    <div class="app-home">
      <div class="top_con">
        <div class="yun_con1">
          <img src="@/assets/newMedal/kkq/7.png" alt="" />
        </div>
        <div class="yun_con2">
          <img src="@/assets/newMedal/kkq/8.png" alt="" />
        </div>
        <div class="title_con">
          <img src="@/assets/newMedal/kkq/4.png" alt="" />
        </div>
        <div class="userInfo">
          <img :src="list.receivericon" alt="" />
          <div>{{ list.receivername }}</div>
        </div>
        <div class="top_content" v-if="list.remarks">
          {{ list.remarks }}
        </div>
        <div class="year_con">
          <img
            v-if="list.companyAge == 5"
            src="@/assets/newMedal/kkq/5.png"
            alt=""
          />
          <img
            v-if="list.companyAge == 10"
            src="@/assets/newMedal/kkq/9.png"
            alt=""
          />
          <img
            v-if="list.companyAge == 15"
            src="@/assets/newMedal/kkq/10.png"
            alt=""
          />
          <img
            v-if="list.companyAge == 20"
            src="@/assets/newMedal/kkq/11.png"
            alt=""
          />
        </div>
      </div>
      <div class="send_btn">
        <el-button @click="goBack">返回</el-button>
      </div>
      <!-- <div class="footer_con">
        <div class="send_con1">
          <div class="send_people">抄送人：</div>
          <div class="people">{{ list.ccers }}</div>
        </div>
      </div> -->
    </div>

    <!-- <div
      class="app-home"
      :class="
        list.medalName?.includes('5')
          ? 'app-home1'
          : list.medalName?.includes('10')
          ? 'app-home2'
          : list.medalName?.includes('15')
          ? 'app-home3'
          : list.medalName?.includes('20')
          ? 'app-home4'
          : 'app-home1'
      "
    >
      <div class="top">
        <div>
          <img :src="list.receivericon" alt="" />
          <div>{{ list.receivername }}</div>
        </div>
        <div class="top_content" v-if="list.remarks">
          {{ list.remarks }}
        </div>
        <div class="top_content" v-else>
          亲爱的{{ list.receivername }}，恭喜入职{{
            list?.valueNum[0]
          }}年。我们携手共进{{
            list?.valueNum[0]
          }}年，感谢你的付出。让我们保持热爱，一起奔赴未来!
        </div>
      </div>
      <div class="send">
        <el-button @click="goBack">返回</el-button>
      </div>
      <div class="send_con">
        <div class="send_people">抄送人：</div>
        <div class="people">{{ list.ccers }}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import api from "@/apis/medal";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "quaquakaDetail",
  data() {
    return {
      list: {
        valueNum: []
      },
      showTip: false,
      message: "",
      disabled: false,
      id: "",
      cclist: [],
      activeHeart: true,
      activeUpvote: true,
      showComment: false,
      comment: "",
      heartnums: 0,
      likesnums: 0,
      empno: "",
      pinglun: true,
      showHeart: true,
      showUpvote: true,
      imgUrl: ""
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    this.id = this.$route.query.id;
    let token = window.sessionStorage.empNo;
    let hrToken = getToken();
    //获取token
    if (token) {
      this.empno = hrToken;
      this.getList(token);
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          this.getList(res);
        });
      });
    }
  },
  //销毁时，清除sessionStorage中的isShowBadge
  beforeDestroy() {
    sessionStorage.setItem("isShowBadge", true);
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));

            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //返回
    goBack() {
      this.$router.back();
    },
    //获取列表
    getList(token) {
      api
        .medalCardDetailApi({
          id: this.id,
          empno: token,
          channel: this.$route.query.value
        })
        .then(res => {
          if (res.code == 200) {
            const checkList =
              res.data.receiverEmpno +
              "," +
              res.data.senderEmpno +
              "," +
              res.data.ccEmpno;

            if (checkList.includes(token)) {
              this.list = res.data;
              this.list.valueNum = res.data.medalName.match(/\d+/g) || [];
              this.list.ccers = res.data.ccers.join(";");
              // setInterval(function () {
              //   this.heartnums = res.data.heartnums;
              //   this.likesnums = res.data.likesnums;
              // }, 4000);
            } else {
              this.$router.push({
                path: "/mobile/medal"
              });
            }
          }
        })
        .catch(err => {
          if (err.code === 0) {
            this.$message({
              type: "error", // success error warning
              message: err.message,
              duration: 2000
            });
          }
        });
    },
    //点击回复
    handleReply() {
      this.showTip = true;
    },
    //取消回复
    handelNo() {
      this.showTip = false;
    },
    //确认回复
    handelOk() {
      this.disabled = true;
      const data = {
        id: this.id,
        reason: this.message,
        // empno: this.list.senderEmpno
        empno: getToken()
      };
      api
        .medalCardReplyApi(data)
        .then(data => {
          this.disabled = false;
          this.showTip = false;
          this.getList(this.empno);
          console.log(data, "data");
        })
        .catch(() => {
          this.disabled = false;
        });
    },
    //点击评论
    handleClickComment() {
      this.comment = "";
      this.showComment = true;
    },
    //点击评论
    handleClickActiveComment() {
      this.$message({
        type: "error", // success error warning
        message: "您已经评论，不能进行重复评论",
        duration: 2000
      });
    },
    //取消评论
    handelNoComment() {
      this.showComment = false;
    },
    //评论
    handelOkComment() {
      if (!this.comment) {
        return this.$message({
          message: "请填写评论内容",
          type: "warning"
        });
      }
      if (!this.disabled) {
        const data = {
          id: this.id,
          reason: this.comment,
          empno: getToken()
        };
        this.disabled = true;
        api
          .medalCardCommentApi(data)
          .then(data => {
            this.showComment = false;
            this.getList(this.empno);
            console.log(data, "data");
            setTimeout(() => {
              this.disabled = false;
            }, 2000);
          })
          .catch(error => {
            this.showComment = false;
            this.$message({
              type: "error", // success error warning
              message: error.message,
              duration: 2000
            });
          });
      }
    },
    // 比心
    handleHeart() {
      if (this.showHeart) {
        this.activeHeart = false;
        const json = {
          id: this.id,
          type: 2,
          empno: getToken()
        };
        this.showHeart = false;
        api
          .medalCardLikesApi(json)
          .then(() => {
            this.getList(this.empno);
            this.showHeart = true;
          })
          .catch(error => {
            this.$message({
              type: "error", // success error warning
              message: error.message,
              duration: 2000
            });
          });
      }
    },
    // 点击比心
    handleActiveHeart() {
      this.$message({
        type: "error", // success error warning
        message: "您已经对当前徽章进行过比心",
        duration: 2000
      });
      // const json = {
      //   id: this.id,
      //   type: 2
      // };
      // api.likesApi(json).then(() => {
      //   this.getList();
      // }).catch((error) => {
      //   this.$message({
      //     type: "error", // success error warning
      //     message: error.message,
      //     duration: 2000,
      //   });
      // });
    },
    // 点赞
    handleClickUpvote() {
      if (this.showUpvote) {
        this.activeUpvote = false;
        const json = {
          id: this.id,
          type: 1,
          empno: getToken()
        };
        this.showUpvote = false;
        api
          .medalCardLikesApi(json)
          .then(res => {
            this.getList(this.empno);
            console.log(res);
            this.showUpvote = true;
          })
          .catch(error => {
            this.$message({
              type: "error", // success error warning
              message: error.message,
              duration: 2000
            });
          });
      }
    },
    // 点击点赞
    handleClickActiveUpvote() {
      this.$message({
        type: "error", // success error warning
        message: "您已经对当前徽章进行过点赞",
        duration: 2000
      });
      // const json = {
      //   id: this.id,
      //   type: 1
      // };
      // api.likesApi(json).then((res) => {
      //   this.getList();
      //   console.log(res);
      // }).catch((error) => {
      //   this.$message({
      //     type: "error", // success error warning
      //     message: error.message,
      //     duration: 2000,
      //   });
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .app-home,
  .app-home1,
  .app-home2,
  .app-home3 {
    width: 100%;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }
  .app-home,
  .app-home1,
  .app-home2,
  .app-home3 {
    width: 100%;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }
}

@media screen and (min-width: 600px) {
  .app-home,
  .app-home1,
  .app-home2,
  .app-home3 {
    width: 276px * $zoom;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }

  .app-home,
  .app-home1,
  .app-home2,
  .app-home3 {
    // width: 276px * $zoom;
    width: 261px * $zoom;
    background: rgba(244, 245, 248, 1);
    min-height: 100vh;
  }
}

@keyframes floatAndFade {
  0% {
    opacity: 0;
    /* 初始不透明度为1 */
  }

  25% {
    opacity: 0.5;
  }

  50% {
    opacity: 1;
  }

  75% {
    opacity: 0.5;
    /* 保持不透明度 */
  }

  100% {
    opacity: 0;
    /* 最终透明度为0 */
  }
}

.box {
  width: 100%;
  display: flex;
  justify-content: center;

  .dialog {
    height: 190px * $zoom;
    padding: 30px;

    .dialog-people {
      margin-bottom: 30px;
    }

    .dialog-reason {
      ::v-deep {
        .van-cell {
          background: rgba(244, 244, 244, 1);
          margin-top: 30px;
          height: 280px;
        }

        .van-field__control {
          height: 200px !important;
        }
      }
    }

    .dialog-btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 30px;
      width: 100%;

      button {
        width: 200px;
        height: 80px;
        border-radius: 40px;
        font-size: 28px;
      }
    }
  }

  @keyframes heartAndRotate {
    0% {
      opacity: 0;
      transform: scale(0.4);
      /* 初始不透明度为1 */
    }

    15% {
      opacity: 0.3;
      // transform: scale(0.5);
    }

    25% {
      opacity: 0.5;
      // transform: scale(0.6);
    }

    35% {
      opacity: 0.8;
      // transform: scale(0.7);
    }

    50% {
      opacity: 1;
      // transform: scale(0.8);
    }

    60% {
      opacity: 0.8;
      // transform: scale(1);
    }

    75% {
      opacity: 0.5;
      // transform: scale(1.2);
    }

    90% {
      opacity: 0.3;
      transform: scale(1.3);
    }

    100% {
      opacity: 0;
      /* 最终透明度为0 */
      transform: scale(1.5);
    }
  }

  .app-home {
    background: url("~@/assets/newMedal/kkq/12.png");
    background-size: 100% 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
  }
  .app-home1 {
    background: url("~@/assets/newMedal/kkq/bg5.png");
    background-size: 100% 100%;
    position: relative;
  }
  .app-home2 {
    background: url("~@/assets/newMedal/kkq/bg10.png");
    background-size: 100% 100%;
    position: relative;
  }
  .app-home3 {
    // background: url("~@/assets/medal/quaquaka/badge1_3.png");
    background: url("~@/assets/newMedal/kkq/bg15.png");
    background-size: 100% 100%;
    position: relative;
  }
  .app-home4 {
    // background: url("~@/assets/medal/quaquaka/badge1_3.png");
    background: url("~@/assets/newMedal/kkq/bg20.png");
    background-size: 100% 100%;
    position: relative;
  }
  .jinbi1 {
    position: absolute;
    top: 10px;
    left: calc(50% - 200px);
    display: flex;
    align-items: center;
    animation: floatAndFade 4s linear forwards;

    img {
      width: 80px;
      height: 80px;
    }

    span {
      font-size: 40px;
    }
  }
  .top_con {
    width: 100%;
    // height: 100%;
    background: url("~@/assets/newMedal/kkq/2.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-bottom: 30px;
    .yun_con1 {
      width: 122px;
      height: 114px;
      position: absolute;
      top: 200px;
      left: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .yun_con2 {
      width: 135px;
      height: 133px;
      position: absolute;
      bottom: -40px;
      right: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title_con {
      width: 420px;
      height: 120px;
      margin-top: 200px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .userInfo {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      width: 100%;
      font-size: 28px;
      padding: 10px 60px;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-right: 20px;
      }
    }
    .top_content {
      font-size: 26px;
      padding: 0px 60px 0 60px;
      // overflow-y: auto;
      // height: 9vh;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .year_con {
      width: 662px;
      height: 486px;
      padding: 0px 60px 0 60px;
      margin-top: 20px;
      margin-bottom: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .send_btn {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin: 8vh 0 80px 0;
    ::v-deep {
      .el-button {
        width: 55%;
        height: 82px;
        color: #ffffff;
        font-size: 28px;
        // line-height: 62px;
        background: linear-gradient(333deg, #0aad82 0%, #61e69e 100%);
        border-radius: 36px;
        border: 0;
      }
    }
  }
  .footer_con {
    width: 100%;
    height: 280px;
    // background: url("~@/assets/newMedal/kkq/6.png");
    // background-size: 100% 100%;
    margin-top: 1px;
    position: relative;
    .send_con1 {
      position: absolute;
      top: 30px;
      left: 11%;
    }
    .send_people {
      font-size: 30px;
      // width: 50%;
    }
    .people {
      height: 100px;
      width: 79%;
      font-weight: 400;
      font-size: 28px;
      color: #282b32;
      // border-radius: 30px;
      // backdrop-filter: blur(10px);
      // padding: 20px 40px;
      // box-shadow: 0 0 20px rgba(32, 41, 74, 0.06);
      margin-top: 10px;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
      overflow-x: auto;
      // white-space: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .heartCon {
    width: 78%;
    height: 28%;
    position: absolute;
    top: 32%;
    left: 16%;
    animation: heartAndRotate 4s ease forwards;

    .back {
      width: 83%;
    }

    .dianzan {
      width: 38%;
      position: absolute;
      top: 38%;
      left: 21%;
    }
  }
  .top {
    position: absolute;
    top: 23vh;
    left: 10%;
    font-size: 28px;
    width: 80%;
    div:nth-child(1) {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-right: 20px;
      }
    }
    .top_content {
      font-size: 26px;
      overflow-y: auto;
      height: 9vh;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .operation {
    position: absolute;
    top: 54%;
    left: 16%;
    display: flex;
    align-items: center;
    .bixin {
      margin-right: 20px;
      border: 1px solid #000;
      background: #fff;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    }
    img {
      width: 30px;
      height: 30px;
    }
  }
  .send {
    width: 100%;
    position: absolute;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    bottom: 23vh;
    ::v-deep {
      .el-button {
        width: 260px;
        height: 62px;
        color: #ffffff;
        font-size: 28px;
        // line-height: 62px;
        background: linear-gradient(333deg, #0aad82 0%, #61e69e 100%);
        border-radius: 36px;
      }
    }
    img {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      margin-right: 20px;
    }
    div {
      background: #1dbf89;
      border-radius: 20px;
      padding: 20px;
      width: 75%;
      font-size: 28px;
      color: #fff;
    }
  }

  .btn_con {
    position: absolute;
    left: 31%;
    bottom: 23%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .btn {
      width: 350px;
      height: 70px;
      line-height: 70px;
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      border-radius: 9px;
      margin-top: 20px;
      background: #1dbf89;
    }
    // .btn1 {
    //   background: #0bbea7;
    // }
    // .btn2 {
    //   background: #f4895b;
    // }
    // .btn3 {
    //   background: #4ea27c;
    // }
    .btnNo {
      opacity: 0.5;
    }
  }
  .send_con {
    position: absolute;
    left: 11%;
    bottom: 7vh;
    width: 100%;
    // padding: 0 40px;
    // margin-top: 40px;
    // position: relative;
    // .num {
    //   width: 33px;
    //   height: 33px;
    //   line-height: 33px;
    //   text-align: center;
    //   background: #fb7676;
    //   border: 2px solid #ffffff;
    //   border-radius: 50%;
    //   font-weight: 400;
    //   font-size: 19px;
    //   color: #ffffff;
    //   position: absolute;
    //   z-index: 99;
    //   top: -15px;
    //   left: 60px;
    // }
    .send_people {
      font-size: 30px;
      width: 100%;
    }
    .people {
      height: 80px;
      width: 79%;
      font-weight: 400;
      font-size: 28px;
      color: #282b32;
      // border-radius: 30px;
      // backdrop-filter: blur(10px);
      // padding: 20px 40px;
      // box-shadow: 0 0 20px rgba(32, 41, 74, 0.06);
      margin-top: 10px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow-x: auto;
      // white-space: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
